export default __webpack_public_path__ + "static/media/Banner.503d5aeb.png";